/**
 * 사이드바 글쓰기 버튼 컴포넌트 - HeroUI 버전
 */ import React from 'react';
import { Button, Tooltip, cn } from '@heroui/react';
import { motion } from 'framer-motion';
import * as m from "@paraglide/messages";
import { Pen as PenLine, Sparkles } from 'lucide-react';
import { CHAT_TEST_IDS } from '@edusense/shared-constants';
export const WriteButtonHeroUI = ({ showWriteButton, onWriteButtonClick, isTabletView, isMobileSidebar, isIconOnlyMode })=>{
    if (!showWriteButton || !onWriteButtonClick) {
        return null;
    }
    const buttonVariants = {
        initial: {
            scale: 0.9,
            opacity: 0
        },
        animate: {
            scale: 1,
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 400,
                damping: 25
            }
        },
        hover: {
            scale: 1.05,
            transition: {
                type: "spring",
                stiffness: 400,
                damping: 15
            }
        },
        tap: {
            scale: 0.95
        }
    };
    const iconVariants = {
        initial: {
            rotate: 0
        },
        hover: {
            rotate: [
                0,
                -10,
                10,
                -10,
                0
            ],
            transition: {
                duration: 0.5,
                times: [
                    0,
                    0.25,
                    0.5,
                    0.75,
                    1
                ]
            }
        }
    };
    const sparkleVariants = {
        initial: {
            opacity: 0,
            scale: 0
        },
        hover: {
            opacity: [
                0,
                1,
                0
            ],
            scale: [
                0,
                1.2,
                0
            ],
            rotate: 360,
            transition: {
                duration: 1.5,
                repeat: Infinity,
                repeatDelay: 0.5
            }
        }
    };
    const shouldUseIconOnly = typeof isIconOnlyMode === 'boolean' ? isIconOnlyMode : isTabletView;
    if (shouldUseIconOnly) {
        // 태블릿 뷰 - 아이콘 버튼
        return /*#__PURE__*/ React.createElement("div", {
            className: cn("w-full p-2 flex justify-center")
        }, /*#__PURE__*/ React.createElement(Tooltip, {
            content: m.common_edit(),
            placement: "right",
            color: "primary",
            delay: 500,
            classNames: {
                content: "font-medium"
            }
        }, /*#__PURE__*/ React.createElement(motion.div, {
            variants: buttonVariants,
            initial: "initial",
            animate: "animate",
            whileHover: "hover",
            whileTap: "tap",
            className: "flex justify-center"
        }, /*#__PURE__*/ React.createElement(Button, {
            isIconOnly: true,
            color: "primary",
            variant: "shadow",
            size: "lg",
            "data-testid": CHAT_TEST_IDS.OPEN_BUTTON,
            onPress: onWriteButtonClick,
            className: cn("bg-gradient-to-br from-primary-400 to-primary-600", "shadow-lg shadow-primary/40", "hover:shadow-xl hover:shadow-primary/50", "transition-all duration-200")
        }, /*#__PURE__*/ React.createElement(motion.div, {
            variants: iconVariants,
            className: "relative"
        }, /*#__PURE__*/ React.createElement(PenLine, {
            size: 20,
            className: "text-white z-10"
        }), /*#__PURE__*/ React.createElement(motion.div, {
            variants: sparkleVariants,
            className: "absolute -top-1 -right-1"
        }, /*#__PURE__*/ React.createElement(Sparkles, {
            size: 12,
            className: "text-white/80"
        })))))));
    }
    // 데스크톱 뷰 - 전체 버튼
    return /*#__PURE__*/ React.createElement("div", {
        className: cn("w-full p-3", isMobileSidebar ? "px-3" : "px-4")
    }, /*#__PURE__*/ React.createElement(motion.div, {
        variants: buttonVariants,
        initial: "initial",
        animate: "animate",
        whileHover: "hover",
        whileTap: "tap",
        className: "w-full"
    }, /*#__PURE__*/ React.createElement(Button, {
        color: "primary",
        variant: "shadow",
        size: "lg",
        "data-testid": CHAT_TEST_IDS.OPEN_BUTTON,
        onPress: onWriteButtonClick,
        startContent: isMobileSidebar ? /*#__PURE__*/ React.createElement(motion.div, {
            variants: iconVariants
        }, /*#__PURE__*/ React.createElement(PenLine, {
            size: 20
        })) : null,
        endContent: !isMobileSidebar ? /*#__PURE__*/ React.createElement(motion.div, {
            variants: iconVariants,
            className: "relative"
        }, /*#__PURE__*/ React.createElement(PenLine, {
            size: 20
        }), /*#__PURE__*/ React.createElement(motion.div, {
            variants: sparkleVariants,
            className: "absolute -top-1 -right-1"
        }, /*#__PURE__*/ React.createElement(Sparkles, {
            size: 12,
            className: "text-white/80"
        }))) : null,
        className: cn("font-semibold w-full", "bg-gradient-to-br from-primary-400 to-primary-600", "shadow-lg shadow-primary/40", "hover:shadow-xl hover:shadow-primary/50", "transition-all duration-200", isMobileSidebar ? "justify-start" : "justify-end")
    }, m.common_edit())));
};
export default WriteButtonHeroUI;
